import withInputErrorMessage from '../withInputErrorMessage';
import withOptionsSelectValueInitById from './withOptionsSelectValueInitById';
import withFormikSelect from './withSelectFormik';

export const options = [
   {
      value: 'YES',
      label: 'Yes',
      id: 'YES',
      name: 'Yes',
   },
   {
      value: 'NO',
      label: 'No',
      id: 'NO',
      name: 'No',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
